<app-page-title
    *ngIf="testInfo"
    [title]="title"
></app-page-title>

<div
    class="row"
    *ngIf="testInfo"
>
    <div class="col-md-12">
        <div
            class="bg-policy"
            *ngIf="!isSaftTest"
        >
            <h4>{{testTypeName}} Cancellation Policy</h4>
            <div *ngIf="testInfo.isWebDelivery">
                If you are unable to attend a {{testTypeName}} for which you have already registered, you may request a cancellation of your registration.
                If your request for a cancellation is received at least 48 hours before the test date, you will be eligible for a refund
                of 50% of your registration fee. No refunds will be granted for cancellation requests received less than 48 hours before the test date.
            </div>
            <div *ngIf="!testInfo.isWebDelivery">
                If you are unable to attend a {{testTypeName}} for which you have already registered, you may request a cancellation of your registration.
                <br />
                If your request for a cancellation is received at least 7 calendar days before the date of the test, you will be eligible for a refund of 50% of your
                registration fee. You cannot submit a cancellation request, and you will not be eligible for a refund if your test day is less than 7 calendar days away.
            </div>
        </div>
        <div
            class="bg-primary"
            style="padding: 1em;"
            *ngIf="isSaftTest"
        >
            <h4>{{testTypeName}} Cancellation Policy</h4>
            If you are unable to attend a pretest for which you have already registered, you may request a cancellation of your registration.
            Cancellation requests for the pretest can be completed up until 3 calendar days before the date of the pretest.
        </div>

        <br />
        <div class="table-responsive">
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th>Test Date</th>
                        <th>Test Type</th>
                        <th>Test Centre</th>
                        <th>Test Centre Location</th>
                        <th>Registration Number</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{testInfo.testDateTime | date}}</td>
                        <td>{{testInfo.testTypeName}}</td>
                        <td *ngIf="!testInfo.isWebDelivery">{{testInfo.testCentreName}}</td>
                        <td *ngIf="!testInfo.isWebDelivery">{{testInfo.testCentreLocation}}</td>
                        <td *ngIf="testInfo.isWebDelivery">{{testInfo.testTypeName}}</td>
                        <td *ngIf="testInfo.isWebDelivery">{{testInfo.testTypeName}}</td>
                        <td>{{testInfo.regId}}</td>
                        <td [ngSwitch]="isRegistrationCancelRequested">
                            <span *ngSwitchCase="true">
                                <strong>Cancellation Request Received</strong>
                            </span>
                            <span
                                class="text-center"
                                *ngSwitchDefault
                            >
                                <button
                                    type="button"
                                    class="btn btn-primary request-btn"
                                    (click)="requestCancellation()"
                                >Request cancellation</button>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <strong
            *ngIf="errorMessage"
            style="color:red;"
        >{{errorMessage}}</strong>
        <strong *ngIf="successMessage">{{successMessage}}</strong>

    </div>
</div>
